import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, InputLabel, Typography } from '@material-ui/core';

import { SingleDepartmentPicker, SingleLocationPicker } from 'components/Pickers';
import { ValidatedTextFieldNext } from 'components';

const Details: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="h6">{t('common:detail_plural')}</Typography>
      </Grid>
      <Grid item xs>
        <Grid container spacing={5}>
          <Grid item xs>
            <ValidatedTextFieldNext
              fullWidth
              margin="none"
              name="full_name"
              label={t('user:fullName')}
              placeholder={t('user:fullName')}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs>
            <ValidatedTextFieldNext
              fullWidth
              margin="none"
              name="job_title"
              label={t('user:title')}
              placeholder={t('user:title')}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs>
            <InputLabel shrink>{t('user:department')}</InputLabel>
            <SingleDepartmentPicker />
          </Grid>
          <Grid item xs>
            <InputLabel shrink>{t('user:location')}</InputLabel>
            <SingleLocationPicker />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Details;
